import React, { useState, useEffect } from 'react';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { Link as RouterLink } from 'react-router-dom';
import {
  Stack,
  Typography,
  Button,
  Card,
  Grid,
  TextField,
  Chip,
  Menu,
  MenuItem
} from '@mui/material';
import { formatDate, formatCnpjCpf } from '../../../../@core/utils/utilsFunctions';
import { selectLogin, selectClient } from '../../../../store/login/loginSlice';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { NotificationManager } from 'react-notifications';
import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing
} from 'devextreme-react/data-grid';

import configAxios from '../../../../services/configAxios';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';
import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import ReactShortcut from 'react-shortcut';

import FacialRecognition from './FacialRecognition';
import SendWhatsApp from './SendWhatsApp';
import ShowDocuments from '../../../components/multiplesComponents/ShowDocuments';

import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

const allowedPageSizes = [5, 10, 20, 30];

const clients = (props) => {
  const [infosClients, setInfosClients] = useState({});
  const infoStateTemp = useSelector(selectLogin);
  const company = useSelector(selectClient);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const [infosFilter, setInfosFilter] = useState([]);
  const [facialRecog, setFacialRecog] = useState(false);
  const [openModalFacilRecog, setOpenModalRecog] = useState(false);
  const [whatsApp, setWhatsApp] = useState(false);
  const [openModalWhatsApp, setOpenModalWhatsApp] = useState(false);
  const [pdf, setpdf] = useState(null);
  const [openModalPreviewDocument, setOpenModalPreviewDocument] = useState(false);

  useEffect(() => {
    getInfosClients();
  }, []);

  function getInfosClients() {
    /***
     * tables tb_profiles & tb_type_users
     * profiles 1 = admin, 2 = usuario, 3 = vendedor, 4 = Entrevistador
     * typeusers 1 = operadora 2 = corretora
     */
    let router;
    if (infoState.id_type_user !== 2) {
      router = `/clients/infosClients/?dateinitial=${infosFilter.dateinitial}&dateend=${infosFilter.dateend}`;
    } else if (
      infoState.id_type_user === 2 &&
      infoState.id_profile !== 1 &&
      infoState.id_profile !== 2
    ) {
      router = `/clients/infosClients/${infoState.id_broker}/${infoState.id}/?dateinitial=${infosFilter.dateinitial}&dateend=${infosFilter.dateend}`;
    } else {
      router = `/clients/infosClients/${infoState.id_broker}/?dateinitial=${infosFilter.dateinitial}&dateend=${infosFilter.dateend}`;
    }
    configAxios
      .get(router)
      .then((response) => {
        if (infoState.id_profile === 4) {
          let clients = [];
          // if (company !== 'gocare') {
          response.data.forEach((item) => {
            if (
              item.statusvenda === 'Realizar entrevista' ||
              item.statusvenda === 'Aguardando CPT(s)' ||
              item.statusvenda === 'Analisar entrevista'
            ) {
              clients.push(item);
            }
          });
          // }
          setInfosClients(clients);
          return;
        }
        // if (infoState.id_profile === 2 && company === 'gocare') {
        //   let clients = [];
        //   response.data.forEach((item) => {
        //     if (
        //       item.statusvenda === 'Aberta' ||
        //       item.statusvenda === 'Análise' ||
        //       item.statusvenda === 'Aguardando cliente' ||
        //       item.statusvenda === 'Aprovada' ||
        //       item.statusvenda === 'Negada' ||
        //       item.statusvenda === 'Cancelada (Proponente)'
        //     ) {
        //       clients.push(item);
        //     }
        //   });
        //   setInfosClients(clients);
        //   return;
        // }
        setInfosClients(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os clientes, por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleInputsFilters(event) {
    setInfosFilter({ ...infosFilter, [event.target.name]: event.target.value });
  }

  function ActionsButtons(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item.id}
        infos={{
          id: item.id,
          router: 'editClients',
          deleteRouter: 'clients/deleteClient',
          deleteItem: 'a venda selecionada',
          functionGrid: getInfosClients,
          otherInfos: item,
          statusvenda: item.statusvenda
        }}
      />
    ));
  }

  function FormatDate(data) {
    if (data.data) {
      let dateFormated = formatDate(data.data);
      return dateFormated;
    } else {
      return '-';
    }
  }

  function FormatCPFCNPJ(infos) {
    let cpfCnpjFormated = formatCnpjCpf(infos.data.data.cpf_cnpj);
    return cpfCnpjFormated;
  }

  function VerifyStatus(infos) {
    if (
      infoState.id_type_user === 2 &&
      (infos.data.data.statusvenda === 'Negada' ||
        infos.data.data.statusvenda === 'Cancelada pelo proponente')
    ) {
      return '-';
    }

    if (infos.data.data.statusvenda === 'Aberta') {
      return (
        <Chip
          color="warning"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    if (infos.data.data.statusvenda === 'Aguardando operadora') {
      return (
        <Chip
          color="mplan"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    // if (
    //   infos.data.data.statusvenda === 'Realizar entrevista' &&
    //   !infos.data.data.horaentrevis &&
    //   infos.data.data.id_type_client === 1
    // ) {
    //   return (
    //     <Chip color="orange" size="small" variant="contained" label={'Realizar agendamento'}></Chip>
    //   );
    // }

    if (infos.data.data.statusvenda === 'Realizar entrevista') {
      return (
        <Chip
          color="violet"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    if (infos.data.data.statusvenda === 'Analisar entrevista') {
      return (
        <Chip
          color="pblue"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    if (infos.data.data.statusvenda === 'Aguardando CPT(s)') {
      return (
        <Chip
          color="warning"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    if (infos.data.data.statusvenda === 'Aguardando administradora') {
      return (
        <Chip
          color="mplan"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    if (infos.data.data.statusvenda === 'Aprovada') {
      return (
        <Chip
          color="success"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    if (infos.data.data.statusvenda === 'Análise') {
      return (
        <Chip
          color="orange"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    if (infos.data.data.statusvenda === 'Aguardando cliente') {
      return (
        <Chip
          color="warning"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    if (infos.data.data.statusvenda === 'Aguardando corretora') {
      return (
        <Chip
          color="mplan"
          size="small"
          variant="contained"
          label={infos.data.data.statusvenda}></Chip>
      );
    }

    if (
      infos.data.data.statusvenda === 'Negada' ||
      infos.data.data.statusvenda === 'Cancelada pelo proponente'
    ) {
      return (
        <Chip
          color="error"
          size="small"
          variant="contained"
          label={
            infos.data.data.statusvenda === 'Cancelada pelo proponente'
              ? 'Cancelada (Proponente)'
              : infos.data.data.statusvenda
          }></Chip>
      );
    }
  }

  function VerifyOdontologico(infos) {
    const isOdontologico = infos.data.data.odontologico === 'Sim';

    return (
      <Chip
        color={isOdontologico ? 'warning' : 'primary'}
        size="small"
        variant="contained"
        label={isOdontologico ? 'Odontológico' : 'Saúde'}></Chip>
    );
  }

  function Facialrecognition() {
    setFacialRecog(!facialRecog);
  }

  function whatsAppIntegration() {
    setWhatsApp(!whatsApp);
  }

  async function openMaterialBroker(popupState, material) {
    popupState.close();
    setpdf();
    setpdf(
      `https://mplansistemas-vendaonline.s3.sa-east-1.amazonaws.com/${company}/assets/material/${material}.pdf`
    );
    setOpenModalPreviewDocument(true);
  }

  async function openMaterialBrokerWord(popupState, material) {
    popupState.close();
    const link = document.createElement('a');

    if (material === 'layout_beneficiarios_modelo_xlsx') {
      link.href = `https://mplansistemas-vendaonline.s3.sa-east-1.amazonaws.com/${company}/assets/material/${material}.xlsx`;
      link.download = `${material}.xlsx`;
    } else if (material === 'carta_de_coligada_subestipulante') {
      link.href = `https://mplansistemas-vendaonline.s3.sa-east-1.amazonaws.com/${company}/assets/material/${material}.odt`;
      link.download = `${material}.odt`;
    } else {
      link.href = `https://mplansistemas-vendaonline.s3.sa-east-1.amazonaws.com/${company}/assets/material/${material}.pdf`;
      link.download = `${material}.pdf`;
      link.target = '_blank'; // Abre em uma nova aba
      link.rel = 'noopener noreferrer'; // Boa prática de segurança para links externos
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <RenderPage title="Vendas">
      <>
        <ShowDocuments
          openModal={openModalPreviewDocument}
          url={pdf}
          setOpenModal={setOpenModalPreviewDocument}
        />
        <ReactShortcut keys="ctrl+B" onKeysPressed={Facialrecognition} />
        <ReactShortcut keys="ctrl+Q" onKeysPressed={whatsAppIntegration} />

        <FacialRecognition openModal={openModalFacilRecog} setOpenModal={setOpenModalRecog} />
        {company === 'homolog' && (
          <SendWhatsApp openModal={openModalWhatsApp} setOpenModal={setOpenModalWhatsApp} />
        )}
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Lista de propostas
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Utilize as opções abaixo para visualizar as propostas
              </Typography>
            </Grid>
          </Grid>
          <Stack direction="row" justifyContent="end" mb={2}>
            {infoState.id_type_user === 2 && infoState.id_profile === 3 && (
              <Button
                variant="contained"
                component={RouterLink}
                to="/app/addClients"
                startIcon={<Iconify icon="eva:plus-fill" />}>
                Nova
              </Button>
            )}
            {!isMobile && (
              <>
                {whatsApp && (
                  <Button
                    variant="outlined"
                    onClick={() => setOpenModalWhatsApp(true)}
                    sx={{ ml: 1 }}
                    startIcon={<Iconify icon="eva:navigation-2-outline" />}>
                    WhatsApp
                  </Button>
                )}
                {facialRecog && (
                  <Button
                    variant="outlined"
                    onClick={() => setOpenModalRecog(true)}
                    sx={{ ml: 1 }}
                    startIcon={<Iconify icon="eva:smiling-face-outline" />}>
                    Facial
                  </Button>
                )}
                {company === 'gocare' && (
                  <>
                    <PopupState variant="popover" popupId="agravos-popup-menu">
                      {(popupState) => (
                        <React.Fragment>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: 'none', ml: 1 }}
                            startIcon={<Iconify icon="eva:book-open-outline" />}
                            {...bindTrigger(popupState)}>
                            <Typography noWrap sx={{ fontWeight: 'bold' }}>
                              Material de apoio
                            </Typography>
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            <MenuItem
                              onClick={() => {
                                openMaterialBroker(popupState, 'apresentacao_corretores');
                              }}>
                              <Iconify icon="eva:book-outline" sx={{ mr: 1 }} />
                              Apresentação corrretores
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                openMaterialBroker(popupState, 'carta_autorizacao_inclusao');
                              }}>
                              <Iconify icon="eva:bulb-outline" sx={{ mr: 1 }} />
                              Carta de autorização de inclusões
                            </MenuItem>
                          </Menu>
                        </React.Fragment>
                      )}
                    </PopupState>
                    <PopupState variant="popover" popupId="agravos-popup-menu">
                      {(popupState) => (
                        <React.Fragment>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: 'none', ml: 1 }}
                            startIcon={<Iconify icon="eva:globe-2-outline" />}
                            {...bindTrigger(popupState)}>
                            <Typography noWrap sx={{ fontWeight: 'bold' }}>
                              Guias regiões
                            </Typography>
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            <MenuItem
                              onClick={() => {
                                openMaterialBroker(popupState, 'guia_litoral');
                              }}>
                              <Iconify icon="eva:file-text-outline" sx={{ mr: 1 }} />
                              Guia Litoral
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                openMaterialBroker(popupState, 'guia_campinas');
                              }}>
                              <Iconify icon="eva:file-text-outline" sx={{ mr: 1 }} />
                              Guia Campinas
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                openMaterialBroker(popupState, 'guia_sp');
                              }}>
                              <Iconify icon="eva:file-text-outline" sx={{ mr: 1 }} />
                              Guia São Paulo
                            </MenuItem>
                          </Menu>
                        </React.Fragment>
                      )}
                    </PopupState>
                    <PopupState variant="popover" popupId="agravos-popup-menu">
                      {(popupState) => (
                        <React.Fragment>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: 'none', ml: 1 }}
                            startIcon={<Iconify icon="eva:menu-2-outline" />}
                            {...bindTrigger(popupState)}>
                            <Typography noWrap sx={{ fontWeight: 'bold' }}>
                              Fichas associações
                            </Typography>
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            <MenuItem
                              onClick={() => {
                                openMaterialBroker(popupState, 'ficha_associativa_udfe');
                              }}>
                              <Iconify icon="eva:file-outline" sx={{ mr: 1 }} />
                              Ficha associativa UDFE
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                openMaterialBroker(popupState, 'ficha_associativa_abps');
                              }}>
                              <Iconify icon="eva:file-outline" sx={{ mr: 1 }} />
                              Ficha associativa ABPS
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                openMaterialBroker(popupState, 'ficha_associativa_abrapli');
                              }}>
                              <Iconify icon="eva:file-outline" sx={{ mr: 1 }} />
                              Ficha associativa ABRAPLI
                            </MenuItem>
                          </Menu>
                        </React.Fragment>
                      )}
                    </PopupState>
                  </>
                )}
                {company === 'higiasaude' && (
                  <PopupState variant="popover" popupId="agravos-popup-menu">
                    {(popupState) => (
                      <React.Fragment>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ textTransform: 'none', ml: 1 }}
                          startIcon={<Iconify icon="eva:book-open-outline" />}
                          {...bindTrigger(popupState)}>
                          <Typography noWrap sx={{ fontWeight: 'bold' }}>
                            Material de apoio
                          </Typography>
                        </Button>
                        <Menu {...bindMenu(popupState)}>
                          <MenuItem
                            onClick={() => {
                              openMaterialBroker(popupState, 'manual_corretor');
                            }}>
                            <Iconify icon="eva:book-outline" sx={{ mr: 1 }} />
                            Manual corretor
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              openMaterialBroker(popupState, 'tabela_precos');
                            }}>
                            <Iconify icon="eva:bulb-outline" sx={{ mr: 1 }} />
                            Tabela de preços
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              openMaterialBroker(popupState, 'rede_credenciada');
                            }}>
                            <Iconify icon="eva:info-outline" sx={{ mr: 1 }} />
                            Rede credenciada
                          </MenuItem>
                        </Menu>
                      </React.Fragment>
                    )}
                  </PopupState>
                )}
                {company === 'higiasaude' && (
                  <PopupState variant="popover" popupId="agravos-popup-menu">
                    {(popupState) => (
                      <React.Fragment>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ textTransform: 'none', ml: 1 }}
                          startIcon={<Iconify icon="eva:attach-outline" />}
                          {...bindTrigger(popupState)}>
                          <Typography noWrap sx={{ fontWeight: 'bold' }}>
                            Kit corretor
                          </Typography>
                        </Button>
                        <Menu {...bindMenu(popupState)}>
                          <MenuItem
                            onClick={() => {
                              openMaterialBrokerWord(popupState, 'condicoes_gerais.pdf');
                            }}>
                            <Iconify icon="eva:email-outline" sx={{ mr: 1 }} />
                            Condições gerais
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              openMaterialBrokerWord(popupState, 'declaracao_uniao_estavel');
                            }}>
                            <Iconify icon="eva:clipboard-outline" sx={{ mr: 1 }} />
                            Declaração de união estável
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              openMaterialBrokerWord(popupState, 'declaracao_perfil_populacional');
                            }}>
                            <Iconify icon="eva:people-outline" sx={{ mr: 1 }} />
                            Declaração perfil populacional
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              openMaterialBrokerWord(
                                popupState,
                                'layout_beneficiarios_modelo_xlsx'
                              );
                            }}>
                            <Iconify icon="eva:arrow-circle-up-outline" sx={{ mr: 1 }} />
                            Layout de importação de beneficiários
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              openMaterialBrokerWord(
                                popupState,
                                'carta_de_coligada_subestipulante'
                              );
                            }}>
                            <Iconify icon="eva:email-outline" sx={{ mr: 1 }} />
                            Carta de coligação de Sub-estipulante
                          </MenuItem>
                        </Menu>
                      </React.Fragment>
                    )}
                  </PopupState>
                )}
                <Button
                  variant="outlined"
                  onClick={getInfosClients}
                  sx={{ ml: 1 }}
                  startIcon={<Iconify icon="eva:refresh-outline" />}>
                  Atualizar
                </Button>
              </>
            )}
          </Stack>
        </Stack>
        <Card>
          <CustomGrid>
            <CustomInfosForm>
              * Sem filtros, a busca é limitada aos últimos 2000 registros
            </CustomInfosForm>
            <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  name="dateinitial"
                  fullWidth
                  label="Data inicial"
                  variant="outlined"
                  size="small"
                  type="date"
                  // required
                  value={infosFilter.dateinitial || ''}
                  onChange={(event) => HandleInputsFilters(event)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  name="dateend"
                  fullWidth
                  label="Data final"
                  variant="outlined"
                  size="small"
                  type="date"
                  // required
                  value={infosFilter.dateend || ''}
                  onChange={(event) => HandleInputsFilters(event)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              {!isMobile && (
                <Grid item xs={12} md={2}>
                  <Button
                    variant="contained"
                    size="medium"
                    color="primary"
                    onClick={() => getInfosClients()}
                    startIcon={<Iconify icon="eva:funnel-outline" />}
                    sx={{ mr: 2 }}>
                    Filtrar
                  </Button>
                </Grid>
              )}
              {isMobile && (
                <Grid item xs={12} md={2}>
                  <Stack direction="row" alignItems="center" justifyContent="end" sx={{ mb: 1 }}>
                    <Button
                      variant="contained"
                      size="medium"
                      color="primary"
                      onClick={() => getInfosClients()}
                      startIcon={<Iconify icon="eva:funnel-outline" />}
                      sx={{ mr: 2 }}>
                      Filtrar
                    </Button>
                  </Stack>
                </Grid>
              )}
            </Grid>
            <DataGrid
              dataSource={infosClients}
              showBorders={true}
              remoteOperations={true}
              wordWrapEnabled={true}
              allowColumnResizing={true}
              columnAutoWidth={true}
              allowExportSelectedData={true}
              noDataText={'Não foram encontrados registros'}>
              <Column dataField="id" />
              <Column dataField="codclient" caption="Cód. cliente" />
              {/* <Column
                dataField="codsimulation"
                caption="Cód. simulação"
                cellRender={(data) => <Simulation data={data} />}
              /> */}
              <Column dataField="nome" caption="Nome/razão social" />
              <Column
                width={150}
                dataField="cpf_cnpj"
                cellRender={(data) => <FormatCPFCNPJ data={data} />}
                caption="Cpf/Cnpj"
              />
              <Column dataField="tpcontrat" caption="Tipo de contratação" />
              {infoState.tipo === 'Simples c/odonto' && (
                <Column
                  dataField="odontologico"
                  caption="Tipo de venda"
                  width={130}
                  cellRender={(data) => <VerifyOdontologico data={data} />}
                />
              )}
              <Column
                dataField="statusvenda"
                caption="Status da venda"
                width={180}
                cellRender={(data) => <VerifyStatus data={data} />}
              />
              {infoState.id_type_user !== 2 && (
                <Column dataField="empresa_vendedor" caption="Corretora" />
              )}
              <Column dataField="nomevend" caption="Vendedor(a)" />
              <Column
                dataField="datacadastro"
                caption="Dt. cadastro"
                cellRender={(data) => <FormatDate data={data.data.datacadastro} />}
              />
              <Column
                dataField="dtvigencia"
                caption="Dt. vigência"
                cellRender={(data) => <FormatDate data={data.data.dtvigencia} />}
              />
              {infoState.entrevisqualificada == 'Sim' && infoState.id_profile === 4 && (
                <Column
                  dataField="dtentrevis"
                  caption="Dt. entrevista"
                  cellRender={(data) => <FormatDate data={data.data.dtentrevis} />}
                />
              )}
              {infoState.entrevisqualificada == 'Sim' && infoState.id_profile === 4 && (
                <Column
                  dataField="horaentrevis"
                  caption="Horário entrevista"
                  cellRender={(data) => (data.data.horaentrevis ? data.data.horaentrevis : '-')}
                />
              )}
              <Column
                dataField="Ações"
                allowExporting={false}
                allowSorting={false}
                cellRender={(data) => <ActionsButtons data={data} />}
              />
              {/* <StateStoring enabled={true} type="localStorage" storageKey="storage" /> */}
              <SearchPanel visible={true} width={240} placeholder="Procurar..." />
              {!isMobile && (
                <GroupPanel visible={true} emptyPanelText="Arraste as colunas aqui para agrupar" />
              )}
              <Scrolling rowRenderingMode="virtual"></Scrolling>
              <Paging defaultPageSize={10} />
              <Pager
                visible={true}
                allowedPageSizes={allowedPageSizes}
                showPageSizeSelector={true}
                showInfo={true}
                showNavigationButtons={true}
              />
              <ColumnChooser
                enabled={true}
                title={'Escolher uma coluna'}
                emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
              />
              <ColumnFixing enabled={true} />
              <HeaderFilter visible={true} allowSearch={true} />
            </DataGrid>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default clients;
